import { firebase } from "../config/configureFirebase";
import { GetDistance } from "../other/GeoFunctions";
import { onValue, child, push, update } from "firebase/database";

export const formatBookingObject = async (bookingData, settings) => {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const reference = [...Array(6)].map(_ => c[~~(Math.random()*c.length)]).join('');

  const { config } = firebase;
  let today;
  try{
      let res =  await fetch(`https://${config.projectId}.web.app/getservertime`, { method: 'GET', headers: {'Content-Type': 'application/json'}});
      const json = await res.json();
      if(json.time){
        today = json.time;
      } else{
        today = new Date().getTime();
      }
  }catch (err){
    today = new Date().getTime();
  }

  let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
  let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };
  
  let coords = [{latitude: pickUp.lat,longitude: pickUp.lng}];
  if(bookingData.drop.waypointsStr){
      bookingData.drop.waypointsStr.split("|").forEach((point)=>{
          let lat = point.split(',')[0];
          let lng = point.split(',')[1];
          coords.push({latitude: parseFloat(lat), longitude: parseFloat(lng)});
      });
  }
  coords.push({latitude: drop.lat,longitude: drop.lng});
  
  var otp;
  if(bookingData.settings.otp_secure)
      otp = Math.floor(Math.random() * 90000) + 10000;
  else{
      otp = false;
  }
  console.log('coming booking data:', bookingData?.paidBy)
  
  return {
    customer: bookingData.userDetails?.uid || '',
    reference: reference || '',
    customer_email: bookingData.userDetails?.email || '',
    customer_name: (bookingData.userDetails?.firstName || '') + ' ' + (bookingData.userDetails?.lastName || ''),
    customer_contact: bookingData.userDetails?.mobile || ' ',
    customer_token: bookingData.userDetails?.pushToken || ' ',
    customer_image: bookingData.userDetails?.profile_image || '',
    selectedFacility: bookingData?.selectedFacility,
    drop: drop || {}, // Assuming `drop` is an object. If not, adjust accordingly.
    pickup: pickUp || {}, // Assuming `pickUp` is an object.
    estimate: bookingData.estimate?.estimateFare || 0,
    estimateDistance: bookingData.estimate?.estimateDistance || 0,
    distance: bookingData.estimate?.estimateDistance || 0,
    estimateTime: bookingData?.estimate?.estimateTime || 0,
    status: bookingData?.booking_type_admin || bookingData?.deliveryWithBid || bookingData.booking_type_fleetadmin ? "NEW" : "PAYMENT_PENDING",
    bookLater: bookingData?.bookLater || false,
    tripdate: bookingData?.bookLater ? bookingData.tripdate || today : bookingData.tripdate , // Default to `today` if `tripdate` is missing.
    bookingDate: today,
    otp: otp || '',
    booking_type_admin: bookingData?.booking_type_admin || false,
    coords: coords || [], // Assuming `coords` is an array.
    waypoints: bookingData.drop?.waypoints || [], // Default to empty array for waypoints.
    roundTrip: bookingData.roundTrip || false,
    tripInstructions: bookingData.tripInstructions || '',
    trip_cost: bookingData?.estimate?.estimateFare?.convenience_fees || 0,
    convenience_fees: bookingData.estimate?.convenience_fees || 0,
    driver_share: (parseFloat(bookingData?.estimate?.estimateFare) - parseFloat(bookingData?.estimate?.convenience_fees) || 0).toFixed(settings.decimal || 2),
    paymentPacket: bookingData.paymentPacket || null,
    preRequestedDrivers: bookingData.preRequestedDrivers || [],
    requestedDrivers: bookingData.requestedDrivers || [],
    driverEstimates: bookingData.driverEstimates || [],
    ...bookingData.instructionData, // Assuming `instructionData` has its own default handling if necessary.
    fleetadmin: bookingData?.fleetadmin || null,
    payment_mode: bookingData?.payment_mode || '',
    booking_from_web: bookingData?.booking_from_web || false,
    deliveryWithBid: bookingData?.deliveryWithBid || false,
    booking_type_fleetadmin: bookingData?.booking_type_fleetadmin || false,
    paidBy: bookingData?.paidBy
  }
}

export const saveAddresses = async (booking, driverLocation) => {
  const { singleUserRef } = firebase;
  let address = booking.drop.add;
  
  onValue(child(singleUserRef(booking.customer), "savedAddresses"), (savedAdd) => {
      if (savedAdd.val()) {
        let addresses = savedAdd.val();
        let didNotMatch = true;
        for (let key in addresses) {
          let entry = addresses[key];
          if (
            GetDistance(
              entry.lat,
              entry.lng,
              booking.drop.lat,
              booking.drop.lng
            ) < 0.1
          ) {
            didNotMatch = false;
            let count = entry.count ? entry.count + 1 : 1;
            update(child(singleUserRef(booking.customer),"savedAddresses/" + key),{ count: count });
            break;
          }
        }
        if (didNotMatch) {
          push(child(singleUserRef(booking.customer),"savedAddresses"),{
            description: address,
            lat: booking.drop.lat,
            lng: booking.drop.lng,
            count: 1,
          });
        }
      } else {
        push(child(singleUserRef(booking.customer),"savedAddresses"),{
          description: address,
          lat: booking.drop.lat,
          lng: booking.drop.lng,
          count: 1,
        });
      }
    }, {onlyOnce: true});
  return address;
};

export const addActualsToBooking = async (booking, address, driverLocation) => {
  const end_time = new Date();
  const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
  const totalTimeTaken = Math.abs(Math.round(diff));
  booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
  booking.endTime = end_time.getTime();
  booking.total_trip_time = totalTimeTaken;
  return booking;
};

export const updateDriverQueue = (booking) => {
  return booking;
};

export const driverQueue= true;